export default (entities, usersToRemove, entityId) =>
	[...entities].map((entity) => {
		if (entity.entityId === entityId) {
			const newContacts = [...entity.contacts.filter(x=> ! usersToRemove.some(c=> c.userId === x.userId ))];
			return {...entity, contacts: newContacts};
		}
		return {...entity};
	});
